import { ref } from 'vue'
import { messageAlert, type TypeMessageAlert } from '../../alert/messageAlert'

export const messageDeleteAccount = ref<TypeMessageAlert>(messageAlert)
